import { render, staticRenderFns } from "./TgAboutBar.vue?vue&type=template&id=4e91c70b&"
import script from "./TgAboutBar.vue?vue&type=script&lang=js&"
export * from "./TgAboutBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports